module.exports = __webpack_public_path__ + "static/img/pro9_tab1.59008d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro9_tab1.jpg
// module id = OntK
// module chunks = 171